<template>
  <div id="invoice-payment-page" v-if="!isDevelopment">
    <vx-card class="mb-5" v-if="invoiceStatus && loggedIn">
      <div class="the-navbar__user-meta flex items-center">
        <vs-dropdown vs-custom-content class="cursor-pointer">
          <div class="con-img mr-3">
            <vs-avatar :src="userInfo.Picture" size="40px" />
          </div>
          <vs-dropdown-menu
            class="vx-navbar-dropdown"
            style="display: none"
          ></vs-dropdown-menu>
        </vs-dropdown>
        <div class="text-left leading-tight">
          <p class="font-semibold">{{ userInfo.FullName }}</p>
          <small>{{ userInfo.StudentNo }}</small>
        </div>
        <vs-spacer></vs-spacer>
        <vs-button
          class="float-right vs-con-loading__container"
          icon-pack="feather"
          icon="icon-log-out"
          color="danger"
          type="filled"
          @click="logout()"
          >{{ $t("User.Logout") }}</vs-button
        >
      </div>
    </vx-card>

    <vs-alert
      color="danger"
      :title="$t('InvoicePayNotifyTitle')"
      :active.sync="invoiceStatus"
    >
      <span>{{ invoiceStatusText }}</span>
    </vs-alert>

    <form-wizard
      v-if="!invoice_not_found"
      ref="checkoutWizard"
      color="rgba(var(--vs-primary), 1)"
      :start-index="
        invoiceData &&
        invoiceData.IsPaymentRequired &&
        invoiceData.IsPaymentRequired.Need &&
        showTransaction
          ? 1
          : 0
      "
      :title="null"
      :subtitle="null"
      :hide-buttons="true"
    >
      <tab-content
        :title="$t('PaytoCC')"
        icon="feather icon-credit-card"
        class="mb-5"
      >
        <div class="vx-row" v-if="!loading">
          <div class="vx-col xl:w-7/12 md:w-12/12 w-full" v-if="loggedIn">
            <vx-card
              class="mb-5"
              v-if="invoiceData && invoiceData.IsPaymentRequired.Need"
            >
              <div class="the-navbar__user-meta flex items-center">
                <vs-dropdown vs-custom-content class="cursor-pointer">
                  <div class="con-img mr-3">
                    <vs-avatar :src="userInfo.Picture" size="40px" />
                  </div>
                  <vs-dropdown-menu
                    class="vx-navbar-dropdown"
                    style="display: none"
                  ></vs-dropdown-menu>
                </vs-dropdown>
                <div class="text-left leading-tight">
                  <p class="font-semibold">{{ userInfo.FullName }}</p>
                  <small>{{ userInfo.StudentNo }}</small>
                </div>
                <vs-spacer></vs-spacer>
                <vs-button
                  class="float-right vs-con-loading__container"
                  icon-pack="feather"
                  icon="icon-log-out"
                  color="danger"
                  type="filled"
                  @click="logout()"
                  >{{ $t("User.Logout") }}</vs-button
                >
              </div>
            </vx-card>

            <!-- <vs-alert
              color="danger"
              :title="$t('InvoicePayNotifyTitle')"
              class="mb-5"
              v-if="invoiceData"
            >
              <span>
                <span v-html="$t('InvoiceAlert3')"></span>
              </span>
            </vs-alert> -->

            <vs-alert
              color="warning"
              :title="$t('InvoicePayNotifyTitle')"
              class="mb-5"
              v-if="invoiceData"
            >
              <span>
                <span v-html="$t('InvoiceAlert1')"></span>
                <br />
                <span v-html="$t('InvoiceAlert2')"></span> 
              </span>
            </vs-alert>

            <vs-alert
              color="primary"
              :title="$t('InvoicePayNotifyTitle')"
              class="mb-5"
              v-if="
                invoiceData &&
                  invoiceData.AvailableDiscounts &&
                  invoiceData.AvailableDiscounts.length > 0
              "
            >
              <span>
                <span v-html="$t('InvoicePayAlert1')"></span>
                <br />
                <span v-html="$t('InvoicePayAlert2')"></span>
              </span>
            </vs-alert>

            <vx-card
              :title="$t('InvoicePayPaymethodTitle')"
              :subtitle="$t('InvoicePayPaymethodDesc')"
              class="mb-base"
              v-if="cartPrice > 0.0"
            >
              <div class="vx-row mt-3">
                <div class="vx-col w-full md:w-1/2 sm:w-1/1 mb-base">
                  <ValidationObserver
                    tag="form"
                    ref="paymentForm"
                    v-on:submit.prevent
                    v-slot="{ invalid }"
                  >
                    <ValidationProvider
                      :name="$t('Card.Name')"
                      rules="required|min:3"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        icon="icon icon-user"
                        icon-pack="feather"
                        :label-placeholder="$t('Card.Name')"
                        :id="fields.cardName"
                        type="text"
                        v-letter-only
                        @input="changeName"
                        data-card-field
                        autocomplete="off"
                        class="w-full no-icon-border card-input__input"
                        v-model="formData.cardName"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider
                      :name="$t('Card.Number')"
                      rules="required|ccnumber"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        type="tel"
                        icon="icon icon-credit-card"
                        icon-pack="feather"
                        :label-placeholder="$t('Card.Number')"
                        :id="fields.cardNumber"
                        @input="changeNumber"
                        @focus="focusCardNumber"
                        @blur="blurCardNumber"
                        data-card-field
                        autocomplete="off"
                        :maxlength="cardNumberMaxLength"
                        class="w-full no-icon-border card-input__input mt-6"
                        v-model="formData.cardNumber"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <div class="vx-row mt-5">
                      <div class="vx-col w-full md:w-1/3 sm:w-1/3 md:mb-base">
                        <label class="text-sm opacity-75">{{
                          $t("Card.Month")
                        }}</label>
                        <v-select
                          :id="fields.cardMonth"
                          :options="cardMonthOptions"
                          v-model="formData.cardMonth"
                          :clearable="false"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="mb-4 md:mb-0"
                          @change="changeMonth"
                          data-card-field
                        />
                      </div>
                      <div class="vx-col w-full md:w-1/3 sm:w-1/3 md:mb-base">
                        <label class="text-sm opacity-75">{{
                          $t("Card.Year")
                        }}</label>
                        <v-select
                          :id="fields.cardYear"
                          :options="cardYearOptions"
                          v-model="formData.cardYear"
                          :clearable="false"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="mb-4 md:mb-0"
                          @change="changeYear"
                          data-card-field
                        />
                      </div>
                      <div class="vx-col w-full md:w-4/12 sm:w-4/12 md:mb-base">
                        <ValidationProvider
                          :name="$t('Card.CVV')"
                          rules="required|min:3|max:4"
                          v-slot="{ errors }"
                        >
                          <vs-input
                            type="tel"
                            :label-placeholder="$t('Card.CVV')"
                            :id="fields.cardCvv"
                            @input="changeCvv"
                            @blur="blurCardNumber"
                            data-card-field
                            autocomplete="off"
                            v-number-only
                            class="w-full no-icon-border card-input__input mt-6"
                            v-model="formData.cardCvv"
                          />

                          <span class="text-danger text-sm">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </ValidationObserver>
                </div>
                <div class="vx-col w-full md:w-1/2 sm:w-1/1 mb-base">
                  <Card
                    :fields="fields"
                    :labels="formData"
                    :isCardNumberMasked="isCardNumberMasked"
                    :randomBackgrounds="false"
                  />
                </div>
              </div>
            </vx-card>
          </div>

          <div v-if="!loggedIn" class="vx-col lg:w-1/1 w-full">
            <div class="vx-row" style="justify-content: center"> 
              <div
                class="
                  vx-col
                  w-full
                  xl:w-2/4
                  lg:w-1/3
                  md:w-1/2
                  sm:w-1/1
                  mb-base
                "
              >
                <vx-card
                  v-if="!loginCard.other"
                  class="text-center cursor-pointer"
                  @click="selectLoginCard('other')"
                >
                  <img
                    src="@/assets/images/pages/graphic-5.png"
                    alt="graphic"
                    width="180"
                    class="mx-auto mb-4"
                  />
                  <h4 class="mb-2">{{ $t("Login.FormTitle3") }}</h4>
                  <small>{{ $t("Login.FormDesc3") }}</small>
                </vx-card>
              
                <vx-card
                  v-if="loginCard.other"
                  :title="$t('Login.FormTitle3')"
                  :subtitle="$t('Login.FormDesc3')"
                  class="mb-base"
                >
                  <div class="mt-3">
                    <ValidationObserver
                      tag="form"
                      ref="loginformOther"
                      v-on:submit.prevent
                      v-slot="{ invalid }"
                    >
                      <ValidationProvider
                        :name="$t('Login.OtherIdentityNumber')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <vs-input
                          icon="icon icon-lock"
                          icon-pack="feather"
                          :label-placeholder="$t('Login.OtherIdentityNumber')"
                          v-model="formDataLoginOther.IdentityNumber"
                          v-on:keyup.enter="loginOther"
                          class="w-full no-icon-border"
                          maxlength="11"
                        />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <ValidationProvider
                        :name="$t('Login.StudentNo')"
                        rules="required|min:9|max:15"
                        v-slot="{ errors }"
                      >
                        <vs-input
                          icon="icon icon-user"
                          icon-pack="feather"
                          :label-placeholder="$t('Login.StudentNo')"
                          v-model="formDataLoginOther.StudentNo"
                          v-on:keyup.enter="loginOther"
                          maxlength="15"
                          class="w-full no-icon-border mt-6"
                        />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <br />
                      <vs-button
                        class="loginButton vs-con-loading__container justify-center"
                        :disabled="invalid"
                        @click="loginOther()"
                        >{{ $t("Login.LoginButton") }}</vs-button
                      >
                      <vs-divider>{{ $t("Login.OR") }}</vs-divider>

                      <vs-button
                      class="bg-danger"
                      @click="redirectLogin()"
                      >{{ $t("Login.EDevletButton") }}</vs-button>
                    </ValidationObserver>
                  </div>
                  <vs-divider>{{ $t("Login.Help") }}</vs-divider>
                  <div class="flex flex-wrap justify-between my-5 ">
                    <a
                      href="https://obs.fsm.edu.tr/oibs/ogrsis/no_query.aspx"
                      target="_blank"
                      >{{ $t("Login.Learn") }}</a
                    >
                  </div>
                </vx-card>
              </div>  
            </div>
          </div>
          <div
            class="vx-col xl:w-5/12 w-full"
            v-if="invoiceData && invoiceData.IsPaymentRequired.Need"
          >
            <vx-card
              class="mb-5"
              v-for="invoice in invoiceDatas"
              :key="invoice.Invoice.InvoiceID"
              :class="{
                'selected-invoice':
                  selectedInvoice == invoice.Invoice.InvoiceID,
              }"
            >
              <div
                class="the-navbar__user-meta flex items-center"
                v-if="invoice.IsPaymentRequired.Need"
              >
                <div class="text-left leading-tight">
                  <p class="font-semibold">
                    {{ invoice.SettingGroup.ProductTitle }}
                  </p>
                  <small>{{ invoice.Invoice.SpecialPrice | currency }}</small>
                </div>
                <vs-spacer></vs-spacer>
                <vs-button
                  class="float-right vs-con-loading__container"
                  color="primary"
                  type="filled"
                  v-if="selectedInvoice != invoice.Invoice.InvoiceID"
                  @click="selectedInvoice = invoice.Invoice.InvoiceID"
                  >{{ $t("InvoiceSelect") }}</vs-button
                >
                <vs-button
                  v-else
                  class="float-right vs-con-loading__container"
                  color="success"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-arrow-right"
                  >{{ $t("InvoiceSelected") }}</vs-button
                >
              </div>
            </vx-card>

            <vx-card :title="$t('InvoicePayInfo')" class="mb-base">
              <div class="flex justify-between mb-2">
                <span class="font-semibold">
                  {{ invoiceData.SettingGroup.ProductTitle }}
                </span>
                <span class="font-semibold">{{
                  invoiceData.Invoice.SpecialPrice | currency
                }}</span>
              </div>
             
              <div v-if="invoiceData.debtRecord">
                <div
                  class="flex justify-between mb-2"
                  v-for="scholarship in invoiceData.debtRecord
                    .AppliedScholarships"
                  :key="scholarship.StudentScholarshipId"
                >
                  <span>{{ scholarship.ScholarshipName }}</span>
                </div>
              </div>

              <vs-divider
                v-if="
                  invoiceData.debtRecord &&
                    invoiceData.debtRecord.Transactions &&
                    invoiceData.debtRecord.Transactions.length
                "
              />

              <div class="flex justify-between mb-2" v-if="balance > 0.0">
                <span class="font-semibold">
                  {{ $t("InvoiceBalanceAmout") }}
                </span>
                <span class="font-semibold text-success">{{
                  balance | currency
                }}
                </span>
              </div>
              <div class="flex justify-between mb-2" v-if="balance > 0.0">
                <span>
                  {{ $t("InvoiceAvailableBalance") }}
                </span>
                <a @click="applyBalance()" href="javascript:;">(tutarı yansıt)</a>
              </div>
              <vs-divider v-if="balance > 0.0"/>

              <div class="flex justify-between mb-2 text-warning" v-if="invoiceData.debtRecord && invoiceData.debtRecord.CanPayPeriodDebit">
                <span>{{ $t("InvoicePayAmountDeposit") }}</span>
                <span>{{ invoiceData.debtRecord.PeriodAmount | currency}}
                  <span v-if="invoiceData.debtRecord.CurrencyRateAmount != 1">(${{ invoiceData.debtRecord.PeriodAmountCurrency }} x {{ invoiceData.debtRecord.CurrencyRateAmount }})</span>
                </span>
              </div>

              <div
                v-if="
                  invoiceData.debtRecord &&
                    invoiceData.debtRecord.Transactions &&
                    invoiceData.debtRecord.Transactions.length
                "
                class="flex justify-between mb-2"
              >
                <span>{{ $t("InvoicePayPaidAmount") }}</span>
                <span class="text-danger"
                  >-{{
                    invoiceData.debtRecord.Transactions.reduce(
                      (a, b) => a + b.PayAmount,
                      0
                    ) | currency
                  }}</span
                >
              </div>
              
              <div class="flex justify-between mb-2" v-if="invoiceData.debtRecord && invoiceData.debtRecord.CanPayPeriodDebit">
                <span class="font-semibold">{{
                  $t("InvoicePayAmountDepositRemaining")
                }}</span>
                <span class="font-semibold">{{
                  calcDepositRemaining | currency
                }}</span>
              </div>

              <div class="flex justify-between mb-2">
                <span class="font-semibold">{{
                  $t("InvoiceRemainingDebt")
                }}</span>
                <span class="font-semibold">{{
                  invoiceData.Invoice.InvoicePrice | currency
                }}</span>
              </div>
               
              <!-- <div v-if="invoiceData.PaidAmount" class="flex justify-between mb-2">
                <span>{{ $t('InvoicePayPaidAmount') }}</span>
                <span class="text-danger">-{{ invoiceData.PaidAmount | currency }}</span>
              </div>-->

              <vs-divider />

              <div
                v-if="
                  invoiceData.AvailableDiscounts &&
                    invoiceData.AvailableDiscounts.length > 0 &&
                    payFormData.Installment <= 1 &&
                    $options.filters.v_currency(payPrice) ==
                      invoiceData.IsPaymentRequired.Amount
                "
              >
                <div
                  class="flex justify-between mb-2"
                  v-for="discount in invoiceData.AvailableDiscounts"
                  v-bind:key="discount.RuleID"
                >
                  <span>{{ discount.DiscountDesc }}</span>
                  <span class="text-danger"
                    >-{{ calculateDiscount(discount) | currency }}</span
                  >
                </div>
              </div>
              <div
                class="flex justify-between mb-2"
                v-if="
                  payFormData.Installment > 1 && selectedInstallmentData.Index
                "
              >
                <span>{{
                  $t("InvoicePayInstallmentPrice", {
                    index:
                      payFormData.Installment +
                      selectedInstallmentData.ExtraInstallment,
                  })
                }}</span>
                <span class="text-success"
                  >+{{
                    ($options.filters.v_currency(payPrice) -
                      selectedInstallmentData.TotalPrice)
                      | currency
                  }}</span
                >
              </div>
              <div class="flex justify-between">
                <span class="font-semibold">{{ $t("InvoicePayAmount") }}</span>
                <span class="font-semibold">{{ cartPrice | currency }}
                  <span v-if="invoiceData.debtRecord && invoiceData.debtRecord.CurrencyRateAmount != 1">(${{ invoiceData.debtRecord.CashAmountCurrency }} x {{ invoiceData.debtRecord.CurrencyRateAmount }})</span>
                </span>
              </div> 
              <vs-divider />

              <div
                class="flex"
                style="justify-content: flex-end; align-items: center"
              >
                <span class="mr-5 font-semibold">{{
                  $t("InvoiceAmountWantPay")
                }}</span>
                <vs-input
                  :disabled="binBusy"
                  v-model="payPrice"
                  name="item-price"
                  v-currency
                  style="max-width: 105px"
                  @input="payPriceFocus()"
                  @blur="payPriceChange()"
                />
              </div>
            </vx-card>

            <vx-card
              v-if="
                loggedIn && invoiceData && invoiceData.IsPaymentRequired.Need
              "
              :title="$t('InvoicePayInstallment')"
            >
              <div class="mt-3">
                <img
                  v-if="
                    invoiceInstallments &&
                      invoiceInstallments.Installments &&
                      invoiceInstallments.Installments.length > 0 &&
                      invoiceInstallments.Logo
                  "
                  :src="invoiceInstallments.Logo"
                  alt="bank-logo"
                  class="float-right inline-flex brand-image"
                />

                <ul>
                  <li
                    v-show="
                      isIsbank
                    "
                  >
                    <p class="text-sm mb-5 text-danger">
                      {{
                        $t("InvoiceIsbankAlert")
                      }}
                    </p>
                  </li>
                  <li class="mb-4">
                    <div class="flex flex-wrap justify-between items-center">
                      <vs-radio vs-value="1" v-model="payFormData.Installment">
                        <div class="flex items-center">
                          <span class="ml-5">
                            {{ $t("InvoicePayInstallment1") }} :
                            <b>{{
                              $options.filters.v_currency(this.payPrice) ==
                              invoiceData.Invoice.InvoicePrice
                                ? $options.filters.currency(
                                    invoiceData.IsPaymentRequired.Amount
                                  )
                                : payPrice
                            }}</b>
                          </span>
                        </div>
                      </vs-radio>
                    </div>
                  </li>
                  <li
                    class="mb-4"
                    v-for="installment in invoiceInstallments.Installments"
                    :key="installment.Index"
                  >
                    <div class="flex flex-wrap justify-between items-center">
                      <vs-radio
                        :vs-value="installment.Index"
                        v-model="payFormData.Installment"
                      >
                        <div class="flex items-center">
                          <span
                            class="ml-5 text-sm md:text-base"
                            style="line-height: normal"
                          >
                            {{ installment.Index }}
                            {{
                              installment.ExtraInstallment
                                ? "+ " + installment.ExtraInstallment
                                : ""
                            }}
                            {{ $t("InvoicePayInstallment2") }}
                            <b>{{ installment.MonthlyPrice | currency }}</b>
                            {{ $t("InvoicePayInstallment3") }}:
                            <b>{{ installment.TotalPrice | currency }}</b>
                          </span>
                        </div>
                      </vs-radio>
                    </div>
                  </li>
                  <li
                    v-show="
                      formData.cardNumber.length < 7 &&
                        (!invoiceInstallments ||
                          !invoiceInstallments.Installments ||
                          invoiceInstallments.Installments.length == 0)
                    "
                  >
                    <p class="text-sm mt-5">
                      {{ $t("InvoiceInstallmentInfo") }}
                    </p>
                  </li>
                  <li
                    v-show="
                      formData.cardNumber.length >= 7 &&
                        !binBusy &&
                        (!invoiceInstallments ||
                          !invoiceInstallments.Installments ||
                          invoiceInstallments.Installments.length == 0) &&
                        invoiceInstallments.MinimumInstallmentPrice <= 0
                    "
                  >
                    <p class="text-sm mt-5">
                      {{ $t("InvoiceNoInstallmentInfo") }}
                    </p>
                  </li>
                  <li
                    v-show="
                      invoiceInstallments &&
                        invoiceInstallments.MinimumInstallmentPrice >
                          $options.filters.v_currency(this.payPrice)
                    "
                  >
                    <p class="text-sm mt-5">
                      {{
                        $t("InvoiceMinimumInstallmentInfo", {
                          price: invoiceInstallments.MinimumInstallmentPrice,
                        })
                      }}
                    </p>
                  </li>
                </ul>
              </div>
            </vx-card>

            <br />

            <vs-button
              v-if="loggedIn"
              class="w-full paymentSubmit vs-con-loading__container"
              size="large"
              @click="doPayment()"
              color="success"
              type="filled"
              icon-pack="feather"
              icon="icon-shopping-cart"
              >{{ $t("Card.Payment") }}</vs-button
            >
          </div>
        </div>
      </tab-content>
      <tab-content
        :title="$t('PaytoSummary')"
        icon="feather icon-printer"
        class="mb-5"
      >
        <vx-card class="mb-5" v-if="loggedIn">
          <div class="the-navbar__user-meta flex items-center">
            <vs-dropdown vs-custom-content class="cursor-pointer">
              <div class="con-img mr-3">
                <vs-avatar :src="userInfo.Picture" size="40px" />
              </div>
              <vs-dropdown-menu
                class="vx-navbar-dropdown"
                style="display: none"
              ></vs-dropdown-menu>
            </vs-dropdown>
            <div class="text-left leading-tight">
              <p class="font-semibold">{{ userInfo.FullName }}</p>
              <small>{{ userInfo.StudentNo }}</small>
            </div>
            <vs-spacer></vs-spacer>
            <vs-button
              class="float-right vs-con-loading__container"
              icon-pack="feather"
              icon="icon-log-out"
              color="danger"
              type="filled"
              @click="logout()"
              >{{ $t("User.Logout") }}</vs-button
            >
          </div>
        </vx-card>

        <vs-alert
          :color="Transaction.TransactionState != 0 ? 'danger' : 'success'"
          :title="$t('InvoicePayNotifyTitle')"
          :active.sync="showTransaction"
        >
          <span>{{ transactionResponse(Transaction) }}</span>

          <span
            v-if="
              Transaction.TransactionState == 0 &&
                invoiceData &&
                invoiceData.IsPaymentRequired &&
                invoiceData.IsPaymentRequired.Need
            "
            @click="$refs.checkoutWizard.prevTab()"
            class="text-inherit underline cursor-pointer"
          >
            <br />
            <br />
            {{
              $t("Transactions.Need", {
                amount: this.$options.filters.currency(
                  invoiceData.IsPaymentRequired.Amount
                ),
              })
            }}
          </span>
          <span
            v-if="
              Transaction.TransactionState == 0 &&
                invoiceData &&
                invoiceData.IsPaymentRequired &&
                !invoiceData.IsPaymentRequired.Need
            "
            @click="
              setFirstInvoice();
              $refs.checkoutWizard.prevTab();
            "
            class="text-inherit underline cursor-pointer"
          >
            <br />
            <br />
            {{ $t("Transactions.Maybe") }}
          </span>
          <span
            v-if="
              Transaction.TransactionState == 5 &&
                invoiceData &&
                invoiceData.IsPaymentRequired.Need
            "
            @click="$refs.checkoutWizard.prevTab()"
            class="text-inherit underline cursor-pointer"
          >
            <br />
            <br />
            {{ $t("TryAgain") }}
          </span>
        </vs-alert>
      </tab-content>
    </form-wizard>

    <form ref="threeDRedirectForm" method="post" :action="threeDInfo.AcsUrl">
      <input type="hidden" name="PaReq" :value="threeDInfo.PAReq" />
      <input type="hidden" name="TermUrl" :value="threeDInfo.TermUrl" />
      <input type="hidden" name="MD" :value="threeDInfo.MD" />
    </form>
    <form
      ref="threeDRedirectFormHidden"
      method="post"
      :action="threeDInfo.AcsUrl"
    >
      <input
        v-for="(val, key) in threeDInfo.Model"
        :key="key"
        type="hidden"
        :name="key"
        :value="val"
      />
    </form>

    <div class="footer-top" :style="loggedIn ? 'bottom:-5%' : ''">
      <vs-images hover="hover" :class="loggedIn ? 'md:justify-end md:pr-20' : ''">
        <vs-image
          src="/logos/all.png"
          :class="loggedIn ? 'md:pr-10' : ''"
        /> 
      </vs-images>
    </div>
  </div>
  <vs-alert
      v-else
      color="danger"
      :title="$t('DevelopmentTitle')" 
    >
      <span>{{ $t('DevelopmentDesc') }}</span>
    </vs-alert>
</template>

<script>
import Vue from "vue";
import InvoiceApi from "@/api/invoice";
import { FormWizard, TabContent } from "vue-form-wizard";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { VueReCaptcha } from "vue-recaptcha-v3";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";

import Card from "@/components/Card.vue";
import moment from "moment" 

var cardValid = require("card-validator");
var developmentInterval = null

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_CAPTCHA });

export default {
  components: {
    FormWizard,
    TabContent,
    ValidationProvider,
    ValidationObserver,
    Card,
    vSelect,
  },
  data() {
    return {
      loading: true,
      isDevelopment: false,
      showTransaction: false,
      Transaction: {},
      threeDInfo: {
        AcsUrl: "",
        PAReq: "",
        TermUrl: "",
        MD: "",
        Model: {},
      },
      binBusy: false,
      checkBinAvailable: true,
      lastBinCN: "",
      invoiceInstallments: [],
      cartPrice: 0,
      payPrice: 0.0,
      balance: 0,
      busyBalance: false,
      lastPayPrice: 0.0,
      formData: {
        cardName: "",
        cardNumber: "",
        cardMonth: { label: "Ay", value: "" },
        cardYear: { label: "Yıl", value: "" },
        cardCvv: "",
        schema: "",
      },
      payFormData: {
        Paymethod: "VakifbankClassic",
        InvoiceKey: "",
        CardOwner: "",
        CardNumber: "",
        CardMonth: "",
        CardYear: "",
        CardCvv: "",
        Installment: 1,
      },
      selectedInstallmentData: {},
      fields: {
        cardNumber: "v-card-number",
        cardName: "v-card-name",
        cardMonth: "v-card-month",
        cardYear: "v-card-year",
        cardCvv: "v-card-cvv",
      },
      minCardYear: new Date().getFullYear(),
      isCardNumberMasked: true,
      mainCardNumber: this.cardNumber,
      cardNumberMaxLength: 19,
      loginCard: {
        student: false,
        personal: false,
        other: false,
      },
      formDataLogin: {
        Username: "",
        Password: "",
        RememberMe: true,
        GoogleReCaptchaResponse: "",
      },
      formDataLoginOther: {
        IdentityNumber: "",
        StudentNo: "",
      },
      submitBusy: false,
      invoiceDatas: [],
      isIsbank: false,
      debtRecords: [],
      lastAccountsData: {},
      invoice_not_found: false,
      accounts: [],
      submitBusy: false,
      logged: false,
      expiryOptions: [],
      selectedInvoice: null,
      cardMonthOptions: [
        { label: "Ay", value: "" },
        { label: "1", value: "01" },
        { label: "2", value: "02" },
        { label: "3", value: "03" },
        { label: "4", value: "04" },
        { label: "5", value: "05" },
        { label: "6", value: "06" },
        { label: "7", value: "07" },
        { label: "8", value: "08" },
        { label: "9", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
      ],
    };
  },
  directives: {
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      },
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }
          return true;
        }
        el.addEventListener("keypress", checkValue);
      },
    },
  },
  watch: {
    "payFormData.Installment"() {
      this.calcCartPrice();
    },
    cardYear() {
      if (this.formData.cardMonth < this.minCardMonth) {
        this.formData.cardMonth = "";
      }
    },
    selectedInvoice() {
      if (this.invoiceData) {
        this.cartPrice = this.invoiceData.IsPaymentRequired.Amount || 0;
        this.payPrice = this.$options.filters.currency(this.cartPrice);
        this.payPriceChange();
      }
    },
  },
  computed: { 
    invoiceData() {
      if (!this.selectedInvoice) return null;

      const invoiceData = this.invoiceDatas.find(
        (x) => x.Invoice.InvoiceID == this.selectedInvoice
      );

      if (invoiceData) {
        const findDebtRecords = this.debtRecords.find(
          (x) => x.StudentDebitId == invoiceData.SettingGroup.InvoiceSettingKey
        );
        invoiceData.debtRecord = findDebtRecords;
      }

      return invoiceData;
    },
    calcDepositRemaining(){
      var remaining = 0;

      if (this.invoiceData && this.invoiceData.debtRecord && this.invoiceData.debtRecord.CanPayPeriodDebit){ 
        if (this.invoiceData.debtRecord.PeriodAmount > 0){
          var totalPay = this.invoiceData.debtRecord.Transactions.reduce(
            (a, b) => a + (b.PayAmount / b.CurrencyRateAmount),
            0
          );

          remaining = this.invoiceData.debtRecord.PeriodAmountCurrency - totalPay;
          if (remaining < 0)
            remaining = 0;
          
          remaining = remaining * this.invoiceData.debtRecord.CurrencyRateAmount
        }
      }
      return remaining;
    },
    cardType() {
      let number = this.formData.cardNumber;
      if (!number) return "";

      let re = new RegExp("^4");
      if (number.match(re) != null) return "VISA";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "Amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "MasterCard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "Discover";

      re = new RegExp("^62");
      if (number.match(re) != null) return "UnionPay";

      re = new RegExp("^9792");
      if (number.match(re) != null) return "TROY";

      re = new RegExp("^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}");
      if (number.match(re) != null) return "dinersclub";

      re = new RegExp("^35(2[89]|[3-8])");
      if (number.match(re) != null) return "Jcb";

      return ""; // default type
    },
    cardYearOptions() {
      var items = [{ label: this.$t("Card.Year"), value: "" }];
      for (let index = 0; index <= 12; index++) {
        items.push({
          label: index + this.minCardYear,
          value: index + this.minCardYear,
        });
      }
      return items;
    },
    minCardMonth() {
      if (this.formData.cardYear === this.minCardYear)
        return new Date().getMonth() + 1;
      return 1;
    },
    loggedIn() {
      this.logged;
      return (this.logged = this.$store.state.auth.isUserLoggedIn());
    },
    userInfo() {
      this.logged;
      if (
        $cookies.isKey(process.env.VUE_APP_COOKIE_AUTH_UI) &&
        this.$auth.isAuthenticated()
      ) {
        return $cookies.get(process.env.VUE_APP_COOKIE_AUTH_UI);
      } else {
        return {};
      }
    },
    invoiceStatus() {
      return (
        this.invoice_not_found ||
        (this.invoiceData != null &&
          !this.invoiceData.IsPaymentRequired.Need &&
          !this.showTransaction)
      );
    },
    invoiceStatusText() {
      if (this.invoice_not_found) {
        return this.$t("InvoicePayNotFound", {
          studentNo: this.userInfo.StudentNo,
        });
      } else if (
        this.invoiceData != null &&
        !this.invoiceData.IsPaymentRequired.Need
      ) {
        return this.$t("InvoicePayNeedPay", {
          studentNo: this.userInfo.StudentNo,
        });
      }
    },
  },
  methods: {
    redirectLogin(){
      window.location.assign("https://portal.fsm.edu.tr/api/auth/edevletWithProcess?process=eodeme-login");
    },
    setFirstInvoice() { 
      
      if (this.busyBalance)
        return;


      if (this.invoiceDatas && this.invoiceDatas.length > 0) {
        var findNeedInvoice = this.invoiceDatas.find((x) => {
          return x.IsPaymentRequired.Need;
        });
        
        if (findNeedInvoice)
          this.selectedInvoice = findNeedInvoice.Invoice.InvoiceID;
        else {
          this.selectedInvoice = null;
          this.invoice_not_found = true;
        }
      }
    },
    calcCartPrice() {
      if (!this.invoiceData) return;

      if (
        this.payFormData.Installment <= 1 ||
        !this.invoiceInstallments ||
        !this.invoiceInstallments.Installments ||
        this.invoiceInstallments.Installments.length == 0
      ) {
        this.cartPrice = this.invoiceData.IsPaymentRequired.Amount || 0;
        this.selectedInstallmentData = {};
        if (
          this.$options.filters.v_currency(this.payPrice) ==
          this.invoiceData.Invoice.InvoicePrice
        )
          this.payPrice = this.$options.filters.currency(this.cartPrice);
      } else {
        var vm = this;
        var installmentData = this.invoiceInstallments.Installments.find(
          (x) => x.Index == vm.payFormData.Installment
        );

        if (installmentData) {
          this.cartPrice =
            this.invoiceData.Invoice.SpecialPrice > 0.0
              ? this.invoiceData.Invoice.InvoicePrice
              : this.invoiceData.IsPaymentRequired.Amount;
          this.selectedInstallmentData = installmentData;
          this.payPrice = this.$options.filters.currency(
            installmentData.TotalPrice
          );
          return;
        }
      }

      if (
        this.payFormData.Installment <= 1 &&
        (this.$options.filters.v_currency(this.payPrice) == 0.0 ||
          this.$options.filters.v_currency(this.payPrice) ==
            this.invoiceData.IsPaymentRequired.Amount)
      )
        this.cartPrice = this.invoiceData.IsPaymentRequired.Amount;
      else {
        this.cartPrice =
          this.invoiceData.Invoice.SpecialPrice > 0.0
            ? this.invoiceData.Invoice.InvoicePrice
            : this.invoiceData.IsPaymentRequired.Amount;
      }
    },
    payPriceFocus() {
      var v_price = this.$options.filters.v_currency(this.payPrice);

      if (
        v_price != null &&
        v_price > this.invoiceData.IsPaymentRequired.Amount
      ) {
        v_price =
          this.payFormData.Installment <= 1
            ? this.invoiceData.IsPaymentRequired.Amount
            : this.invoiceData.Invoice.InvoicePrice;
        this.payPrice = this.$options.filters.currency(v_price);
      }

      // if (v_price == 0.0) {
      //   this.payPrice = this.$options.filters.currency(
      //     this.payFormData.Installment <= 1
      //       ? this.invoiceData.IsPaymentRequired.Amount
      //       : this.invoiceData.Invoice.SpecialPrice > 0.0
      //       ? this.invoiceData.Invoice.InvoicePrice
      //       : this.invoiceData.IsPaymentRequired.Amount
      //   );
      // }
    },
    async payPriceChange() {
      var v_price = this.$options.filters.v_currency(this.payPrice);

      if (
        this.payFormData.Installment <= 1 &&
        (v_price == null || v_price == 0.0)
      ) {
        setTimeout(async () => {
          this.payPrice = this.$options.filters.currency(
            this.invoiceData.IsPaymentRequired.Amount
          );
          let cn = await this.changeNumber(null, true);
          this.calcCartPrice();
        }, 150);
      } else {
        setTimeout(async () => {
          let cn = await this.changeNumber(null, true);
          this.calcCartPrice();
        }, 150);
      }
    },
    handleLocaleEvent() {
      this.formData.cardMonth = { label: this.$t("Card.Month"), value: "" };
      this.formData.cardYear = { label: this.$t("Card.Year"), value: "" };
    },
    calculateDiscount(discount) {
      var discountPrice = 0;
      if (discount.DiscountRate > 0)
        discountPrice =
          (discount.DiscountRate * this.invoiceData.Invoice.SpecialPrice) / 100;
      if (discount.DiscountPrice > 0) discountPrice += discount.DiscountPrice;

      return discountPrice;
    },
    transactionResponse(transaction) {
      if (transaction) {
        switch (transaction.TransactionState) {
          case 0:
            return this.$t("Transactions.T0");
            break;
          case 1:
            return this.$t("Transactions.T1");
            break;
          case 2:
            return this.$t("Transactions.T2");
            break;
          case 3:
            return this.$t("Transactions.T3");
            break;
          case 4:
            return this.$t("Transactions.T4");
            break;
          case 5:
            return transaction.Response;
            break;
        }
      }
    },
    async applyBalance(){
      var balanceAmount = this.balance;
      if (balanceAmount > this.cartPrice)
        balanceAmount = this.cartPrice;

      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: this.$t('InvoiceBalanceAlertTitle'),
        text: this.$t('InvoiceBalanceAlertDesc', [this.$options.filters.currency(balanceAmount)]),
        accept: this.doApplyBalance,
        acceptText: this.$t('Yes'),
        cancelText: this.$t('Cancel')
      });   
    },
    async doApplyBalance(){
      if (!this.selectedInvoice)
        return;

      this.busyBalance = true; 

      this.$vs.loading({
        color: "#000",
        scale: 0.45,
      });

      try{
        var balanceResponse = await InvoiceApi.applyBalance({InvoiceID: this.selectedInvoice}, this);
          
        if (!balanceResponse.data.error && !balanceResponse.data.errors)
          window.location.reload()
        else
          this.busyBalance = false;
      }
      finally{
        setTimeout(() => {
          try { 
            this.$vs.loading.close();
            this.busyBalance = false;
          } catch {}
        }, 100);
      }
    },
    async doPayment() {
      if (this.isDevelopment)
        return

      const isValid = await this.$refs.paymentForm.validate();

      if (!isValid) {
        this.$vs.notify({
          time: 2500,
          title: this.$t("Warning"),
          text: this.$t("Card.RequiredFields"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
        });
      }

      if (this.submitBusy || !isValid || this.binBusy) return;

      if (!this.formData.cardYear.value || !this.formData.cardMonth.value) {
        this.$vs.notify({
          time: 2500,
          title: this.$t("Warning"),
          text: this.$t("Card.ExpireDateWarning"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-right",
        });
        return;
      } else {
        var expiryValidation = cardValid.expirationDate({
          month: this.formData.cardMonth.value,
          year: this.formData.cardYear.value,
        });
        if (!expiryValidation.isPotentiallyValid) {
          this.$vs.notify({
            time: 2500,
            title: this.$t("Warning"),
            text: this.$t("Card.ExpireDateDanger"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });

          return;
        }
      }

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: ".paymentSubmit",
        scale: 0.45,
      });

      try {
        this.payFormData.InvoiceKey = this.invoiceData.Invoice.InvoiceKey;
        this.payFormData.CardOwner = this.formData.cardName;
        this.payFormData.CardMonth = this.formData.cardMonth.value.toString();
        this.payFormData.CardYear = this.formData.cardYear.value.toString();
        this.payFormData.Schema = this.formData.schema;
        this.payFormData.Installment = this.payFormData.Installment.toString();
        this.payFormData.PayPrice = this.$options.filters.v_currency(
          this.payPrice
        );

        let payResponse = await InvoiceApi.doPayment(this.payFormData, this);

        if (!payResponse.data.error && !payResponse.data.errors) {
          if (!payResponse.data.HiddenForm) {
            this.threeDInfo.AcsUrl = payResponse.data.AcsUrl;
            this.threeDInfo.PAReq = payResponse.data.PAReq;
            this.threeDInfo.TermUrl = payResponse.data.TermUrl;
            this.threeDInfo.MD = payResponse.data.MD;

            setTimeout(() => {
              this.$refs.threeDRedirectForm.submit();
            }, 100);
          } else {
            this.threeDInfo.AcsUrl = payResponse.data.AcsUrl;
            this.threeDInfo.Model = payResponse.data.Model;

            setTimeout(() => {
              this.$refs.threeDRedirectFormHidden.submit();
            }, 100);
          }
        } else {
          setTimeout(() => {
            try {
              this.$vs.loading.close(".paymentSubmit > .con-vs-loading");
            } catch {}
          }, 100);
        }
      } catch {
        setTimeout(() => {
          try {
            this.$vs.loading.close(".paymentSubmit > .con-vs-loading");
          } catch {}
        }, 100);
      } finally {
        this.submitBusy = false;
      }
    },
    async logout() {
      if (this.loggedIn) {
        this.$auth.logOut();
        this.logged = false;
        this.payFormData.Installment = 1;
        this.selectedInstallmentData = {};

        this.checkBinAvailable = true;
        this.lastBinCN = "";
        this.invoiceInstallments = [];
        this.cartPrice = 0;
        this.selectedInvoice = null;
        this.payPrice = 0.0;
        this.balance = 0.0;
        this.busyBalance = false;
        this.formData = {
          cardName: "",
          cardNumber: "",
          cardMonth: { label: this.$t("Card.Month"), value: "" },
          cardYear: { label: this.$t("Card.Year"), value: "" },
          cardCvv: "",
          schema: "",
        };
        this.payFormData = {
          Paymethod: "VakifbankClassic",
          InvoiceKey: "",
          CardOwner: "",
          CardNumber: "",
          CardMonth: "",
          CardYear: "",
          CardCvv: "",
          Installment: 1,
          PayPrice: 0.0,
          Schema: "",
        };

        this.formDataLoginOther = {
          IdentityNumber: "",
          StudentNo: "",
        };

        this.mainCardNumber = "";
        if (this.$route.path != "/payment") {
          this.$router.push({
            name: "payment",
          });
        }
      }
      this.invoice_not_found = false;
      if (this.$refs.checkoutWizard) this.$refs.checkoutWizard.prevTab();
    },
    selectLoginCard(card) {
      this.loginCard.student = false;
      this.loginCard.personal = false;
      this.loginCard.other = false;

      switch (card) {
        case "personal":
          this.loginCard.personal = true;
          break;
        case "student":
          this.loginCard.student = true;
          break;
        case "other":
          this.loginCard.other = true;
          break;
      }
    },
    async login() {
      return;
      const isValid = await this.$refs.loginform.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: ".loginButton",
        scale: 0.45,
      });
      try {
        this.$recaptcha("login").then(async (token) => {
          this.formDataLogin.GoogleReCaptchaResponse = token;
          await this.$auth.login(this.formDataLogin, this);

          let setUserData = {
            InvoiceKey: this.$route.params.invoiceId.toString(),
            LocalUser: true,
          };
          let setUserResult = await InvoiceApi.setUser(setUserData, this);

          if (!setUserResult.data.error && !setUserResult.data.errors) {
            this.logged = true;
            this.formDataLogin.Password = "";
          } else {
            this.$auth.logOut();
            this.logged = false;
          }
          await this.fetchLoadData();
        });
      } finally {
        this.submitBusy = false;
      }
    },

    async loginOther() {
      if (this.isDevelopment)
        return
      
      const isValid = await this.$refs.loginformOther.validate();
      if (this.submitBusy || !isValid || !this.formDataLoginOther) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: ".loginButton",
        scale: 0.45,
      });
      try {
        let setUserData = {
          IdentityNumber: this.formDataLoginOther.IdentityNumber.toString(),
          SpecialKey: this.formDataLoginOther.StudentNo.toString(),
        };
        let setUserResult = await InvoiceApi.getStudentInfo(setUserData, this);

        if (!setUserResult.data.error && !setUserResult.data.errors) {
          this.$auth.localLogin(setUserResult.data.Student);
          this.logged = true;
        } else {
          this.logged = false;
        }
        await this.fetchLoadData(setUserResult);
      } finally {
        this.submitBusy = false;
      }
    },

    async fetchLoadData(customData = null) {
      this.$vs.loading({
        color: "#000",
        scale: 0.45,
      });

      let setUserData = {
        IdentityNumber: this.userInfo.Username.toString(),
        SpecialKey: this.userInfo.StudentNo.toString(),
      };

      var invoiceResult = customData
        ? customData
        : await InvoiceApi.getStudentInfo(setUserData, this);

      if (!invoiceResult.data.error) {
        this.invoiceDatas = invoiceResult.data.Invoices;
        this.debtRecords = invoiceResult.data.DebtRecords;
        this.balance = invoiceResult.data.Balance;

        if (this.invoiceDatas.length > 0) {
          let transactionId = this.$route.params.transactionId;

          if (transactionId && transactionId > 0) {
            console.log("2");
            var checkTransaction = null;

            this.invoiceDatas.map((i) => {
              var _checkTransaction = i.Invoice.Transactions.find(
                (x) => x.TransactionID == transactionId
              );

              if (_checkTransaction) checkTransaction = _checkTransaction;
            });

            if (checkTransaction) {
              this.selectedInvoice = checkTransaction.InvoiceID;

              this.showTransaction = true;
              this.Transaction = checkTransaction;
              this.$refs.checkoutWizard.activateTabAndCheckStep(1);
            } else this.invoice_not_found = true;
          } else this.setFirstInvoice();
        } else this.invoice_not_found = true;
      } else this.invoice_not_found = true;

      setTimeout(() => {
        try {
          this.loading = false;
          this.$vs.loading.close();
          this.busyBalance = false;
        } catch {}
      }, 100);
    },
    generateMonthValue(n) {
      return n < 10 ? `0${n}` : n;
    },
    changeName(e) {
      this.$emit("input-card-name", this.formData.cardName);
    },
    async changeNumber(e, skipLast = false) {
      this.formData.schema = this.cardType;
      let value = this.formData.cardNumber.replace(/\D/g, "");
      this.payFormData.CardNumber = value;
      // american express, 15 digits
      if (/^3[47]\d{0,13}$/.test(value)) {
        this.formData.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 17;
      } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
        // diner's club, 14 digits
        this.formData.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 16;
      } else if (/^\d{0,16}$/.test(value)) {
        // regular cc number, 16 digits
        this.formData.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
          .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
        this.cardNumberMaxLength = 19;
      }
      this.$emit("input-card-number", this.formData.cardNumber);
      var v_price = this.$options.filters.v_currency(this.payPrice);

      if (
        v_price != null &&
        v_price > 0.0 &&
        (skipLast ||
          (value.length >= 6 && this.lastBinCN != value.substring(0, 6)))
      ) {
        this.invoiceInstallments = [];
        this.checkBinAvailable = true;
      }

      if (this.checkBinAvailable && value.length >= 6) {
        if (!this.binBusy) {
          this.$vs.loading({
            color: "#000",
            container: ".paymentSubmit",
            scale: 0.45,
          });
        }
        this.checkBinAvailable = false;
        this.binBusy = true;
        let payAmount =
          this.invoiceData.IsPaymentRequired.Amount == v_price
            ? this.invoiceData.Invoice.InvoicePrice
            : v_price;

        let binResult = await InvoiceApi.getBin({
          InvoiceKey: this.invoiceData.Invoice.InvoiceKey,
          cardNumber: value,
          PayPrice: payAmount,
        });

        setTimeout(() => {
          try {
            this.$vs.loading.close(".paymentSubmit > .con-vs-loading");
          } catch {}
        }, 100);

        if (!binResult.data.error) {
          this.invoiceInstallments = binResult.data;

          if (binResult.data && binResult.data.Logo && binResult.data.Logo.toString().includes('maximum'))
            this.isIsbank = true;
          else
            this.isIsbank = false;
        }

        this.payFormData.Installment = 1;
        this.lastBinCN = value.substring(0, 6);
        this.binBusy = false;
      } else if (value.length < 6) {
        this.checkBinAvailable = true;
        this.invoiceInstallments = [];
        this.lastBinCN = "";
        this.payFormData.Installment = 1;
      }
    },
    changeMonth() {
      this.payFormData.CardMonth = this.formData.cardMonth;
      this.$emit("input-card-month", this.formData.cardMonth);
    },
    changeYear() {
      this.payFormData.CardYear = this.formData.cardYear;
      this.$emit("input-card-year", this.formData.cardYear);
    },
    changeCvv(e) {
      this.payFormData.CardCvv = this.formData.cardCvv;
      this.$emit("input-card-cvv", this.formData.cardCvv);
    },
    invaildCard() {
      let number = this.formData.cardNumber;
      let sum = 0;
      let isOdd = true;
      for (let i = number.length - 1; i >= 0; i--) {
        let num = number.charAt(i);
        if (isOdd) {
          sum += num;
        } else {
          num = num * 2;
          if (num > 9) {
            num = num
              .toString()
              .split("")
              .join("+");
          }
          sum += num;
        }
        isOdd = !isOdd;
      }
      if (sum % 10 !== 0) {
        alert("invaild card number");
      }
    },
    blurCardNumber() {
      if (this.isCardNumberMasked) {
        this.maskCardNumber();
      }
    },
    maskCardNumber() {
      return (this.mainCardNumber = this.formData.cardNumber);
    },
    unMaskCardNumber() {
      this.formData.cardNumber = this.mainCardNumber;
    },
    focusCardNumber() {
      this.unMaskCardNumber();
    },
    toggleMask() {
      this.isCardNumberMasked = !this.isCardNumberMasked;
      if (this.isCardNumberMasked) {
        this.maskCardNumber();
      } else {
        this.unMaskCardNumber();
      }
    },
    checkDevelopment(){
      var momentEnd = moment()
      var momentFirst = moment()
      var current = moment()
      var currentOnly = moment()
      
      var dateEnd = momentEnd.endOf('month').subtract("1", "hours")
      var dateFirst = momentFirst.add("1", "days").startOf('month').add("30", "minutes")
      var dateOnlyFirst = currentOnly.startOf('month').add("30", "minutes")
  
      this.isDevelopment = (current.day() != dateOnlyFirst.day() && current >= dateEnd && moment() <= dateFirst) || (current.day() == dateOnlyFirst.day() && current <= dateOnlyFirst)
    }
  },
  created() {
    this.handleLocaleEvent();
  },
  async mounted() {
    this.checkDevelopment()

    clearInterval(developmentInterval)
    developmentInterval = setInterval(() => {
      this.checkDevelopment()
    }, 1000);

    if (this.$route.query.error){
      this.$vs.notify({
            time: 2500,
            title: this.$t("Error"),
            text: this.$t("Server." + this.$route.query.error),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });

        setTimeout(() => {
          this.$router.push('payment')
        }, 2500);
    }

    if (
      this.loggedIn &&
      this.userInfo &&
      this.userInfo.Username &&
      this.userInfo.StudentNo
    ) {
      this.fetchLoadData();
      this.maskCardNumber();
    } else this.loading = false;
  },
};
</script>
<style lang="scss">
.wizard-navigation {
  margin-bottom: 12%;
}
</style>

<style lang="scss" scoped>
#invoice-payment-page {
  .vue-form-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container {
        margin-bottom: 0 !important;
      }
    }
  }
  .brand-image {
    width: 150px;
    object-fit: cover;
    position: absolute;
    top: -38px;
    right: 5px;
  }
}
</style>

<style>
.footer-top {
  display: block;
  position: absolute;
  left: 5px;
  bottom: -10%;
  width: 100%;
  z-index: -1;
}
.vs-ul-images {
  max-width: 650px;
}
.vs-image {
  width: 100%;
}

.vs-images--ul{
  flex-wrap: unset;
}

.vs-image--img {
  background-repeat: no-repeat;
  background-size: contain;
  cursor: default;
}

.selected-invoice {
  border: 2px solid #28c76f;
  border-radius: 6px;
}
</style>
